import { Typography, Card } from "@mui/material";
import { Box, styled } from "@mui/system";

export const StyledLockerCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  overflow: "hidden",
  border: theme.borders.highlighted,
  display: "flex",
  flexDirection: "column",
  maxHeight: "440.5px",
  minHeight: "440.5px",
  height: "440.5px",
  [theme.breakpoints.only("xl")]: {
    maxHeight: "461.5px",
    minHeight: "461.5px",
    height: "461.5px",
  },

  "@media screen and (min-width: 1393px) and (max-width:1418px)": {
    maxHeight: "474px",
    minHeight: "474px",
    height: "474px",
  },
  "@media screen and (min-width: 1200px) and (max-width:1392px)": {
    maxHeight: "503.5px",
    minHeight: "503.5px",
    height: "503.5px",
  },
  "@media screen and (min-width: 1082px) and (max-width:1199px)": {
    maxHeight: "642.5px",
    minHeight: "642.5px",
    height: "642.5px",
  },
  "@media screen and (min-width: 1065px) and (max-width:1081px)": {
    maxHeight: "656.5px",
    minHeight: "656.5px",
    height: "656.5px",
  },
  "@media screen and (min-width: 997px) and (max-width:1064px)": {
    maxHeight: "676.5px",
    minHeight: "676.5px",
    height: "676.5px",
  },
  "@media screen and (min-width: 960px) and (max-width:996px)": {
    maxHeight: "697.5px",
    minHeight: "697.5px",
    height: "697.5px",
  },
  [theme.breakpoints.down("md")]: {
    maxHeight: "none",
    minHeight: "auto",
    height: "auto",
  },
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.orderCards,
  color: theme.palette.custom.white,
  padding: "0px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  borderTopRightRadius: theme.borderRadius.radius.regular,
  borderTopLeftRadius: theme.borderRadius.radius.regular,
  [theme.breakpoints.down("sm")]: {
    padding: "12px 12px",
    alignItems: "flex-start",
  },
}));

export const StyledHeaderLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  minWidth: 0,
});

export const StyledLockerTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  padding: "30px 0px",
  whiteSpace: "nowrap",
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "18px 0px",
  },
}));
export const StyledBox = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.micro.fontSize,
  gap: "19px",
  display: "flex",
  minWidth: 0,
  flex: 1,
  [theme.breakpoints.down("lg")]: {
    gap: "8px",
  },
}));
export const StyledBoxFragile = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexShrink: 0,
  [theme.breakpoints.down("md")]: {
    gap: "4px",
  },
}));

export const StyledTypographyID = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.tiny.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.xSmall.fontSize,
  },
}));

export const StyledIDBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  color: theme.palette.custom.orderName,
  padding: "8px 12px",
  display: "flex",
  gap: "8px",
  alignItems: "center",
  borderRadius: theme.borderRadius.radius.medium,
  flexShrink: 0,
  [theme.breakpoints.down("xl")]: {
    padding: "5px 8px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "5px 7px",
    gap: "6px",
  },
}));
export const StyledTypographyName = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.micro.fontSize,
  minWidth: 0,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const StyledItemList = styled(Box)(({ theme }) => ({
  padding: theme.padding.size.large,
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  height: "calc(100% - 158.5px)",
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: "12px",
    height: "auto",
    maxHeight: "360px",
  },
}));

export const StyledItem = styled(Box)(({ theme, selected, space }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "nowrap",
  padding: "12px 16px",
  paddingRight: !space ? "16px" : "16px",
  cursor: "pointer",
  backgroundColor: theme.palette.custom.assistBgColor,
  [theme.breakpoints.down("xl")]: {
    padding: "8px 12px",
    paddingRight: "12px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px 10px",
    paddingRight: "10px",
  },
  borderRadius: theme.borderRadius.radius.wallet,
  border: selected && "2px solid #1565c0",
}));

export const StyledFragileBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.errorBg,
  color: theme.palette.custom.danger,
  padding: "5px",
  borderRadius: theme.borderRadius.radius.small,
  fontSize: theme.typography.extraSmall.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.padding.size.large,
  [theme.breakpoints.down("xl")]: {
    padding: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
    gap: "8px",
  },
}));

export const StyledEmptyState = styled(Typography)(({ theme }) => ({
  margin: "auto",
  textAlign: "center",
  color: theme.palette.custom.lightBack,
  fontSize: theme.typography.micro.fontSize,
  padding: theme.padding.size.large,
}));

export const StyledExpiryText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.medium.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.primary,
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
}));

export const StyledExpiryBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minWidth: 0,
});

export const StyledExpiryContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  minWidth: 0,
});
